import {required} from "vuelidate/lib/validators";  
const StrHesapKodlari = {
    data() {
      return { 
          StrHesapKodlariData:{ 
            UstId:"",
            Kod1:"",
            Kod2:"0",
            Kod3:"0",
            Kod4:"0",
            Aciklama:"",
            Parasalustlimit:null,
            Deleted: false   
          }, 
          FormDataType:{ 
            UstId:{FieldName:"UstId",Field:"combobox",FieldTitle:this.$t('StrHesapKodlari.AddEdit.UstId'),ComboDataArray:[]}, 
            Kod1:{FieldName:"Kod1",Field:"input",FieldTitle:this.$t('StrHesapKodlari.AddEdit.Kod1')},
            Kod2:{FieldName:"Kod2",Field:"input",FieldTitle:this.$t('StrHesapKodlari.AddEdit.Kod2')}, 
            Kod3:{FieldName:"Kod3",Field:"input",FieldTitle:this.$t('StrHesapKodlari.AddEdit.Kod3')},
            Kod4:{FieldName:"Kod4",Field:"input",FieldTitle:this.$t('StrHesapKodlari.AddEdit.Kod4')},
            Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle:this.$t('StrHesapKodlari.AddEdit.Aciklama')},  
            Parasalustlimit:{FieldName:"Parasalustlimit",Field:"input",FieldTitle:this.$t('StrHesapKodlari.AddEdit.Parasalustlimit'),FieldType:"number"}
          }   
      }
    },
    validations:{ 
      FormData: {
        Kod1: {  },  
        Kod2: {  }, 
        Kod3: {  }, 
        Kod4: {  },   
        UstId: {  },
        Aciklama: {  },
        Parasalustlimit:{ required}
      }
 
  },
  created(){ 
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }  
    let Filter = "&Tip=1";
    this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.UstId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Kod1+"."+res.Data[i].Kod2+"."+res.Data[i].Kod3+"."+res.Data[i].Kod4+" "+res.Data[i].Aciklama})
        }    
    }); 
    
  }
}
export default StrHesapKodlari